var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"outlined":"","label":"Select website","items":_vm.list,"item-text":"label","item-value":"id"},model:{value:(_vm.websiteId),callback:function ($$v) {_vm.websiteId=$$v},expression:"websiteId"}})}
var staticRenderFns = []

export { render, staticRenderFns }